import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const MoreThick = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      ref={forwardedRef}
      width={size}
      height={size}
      style={{ width: `${size}px`, height: `${size}px` }}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 9.5C12.6716 9.5 12 8.82843 12 8C12 7.17157 12.6716 6.5 13.5 6.5C14.3284 6.5 15 7.17157 15 8C15 8.82843 14.3284 9.5 13.5 9.5ZM8.00009 9.5C7.17167 9.5 6.50009 8.82843 6.50009 8C6.50009 7.17157 7.17167 6.5 8.00009 6.5C8.82852 6.5 9.50009 7.17157 9.50009 8C9.50009 8.82843 8.82852 9.5 8.00009 9.5ZM1.00012 8C1.00012 8.82843 1.67169 9.5 2.50012 9.5C3.32854 9.5 4.00012 8.82843 4.00012 8C4.00012 7.17157 3.32854 6.5 2.50012 6.5C1.67169 6.5 1.00012 7.17157 1.00012 8Z"
        fill={color}
      />
    </svg>
  )
})

export default MoreThick
